module.exports = __webpack_public_path__ + "static/media/lp_ic_arrow_up.d319d384.svg";